import React, { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setPageName } from '../../../../redux'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import { CustomersResponse } from '../../../../functions/CustomersResponse'
import { customerSearchApi } from '../../../../functions/SearchApi'
import SearchBox from './SearchBox'
import CustomerList from './CustomerList'

function Users() {
  const [search_value, setSearchValue] = useState('')
  const [openTab, setOpenTab] = React.useState(0)
  const [customersType, setCustomersType] = useState([NaN, NaN, NaN, NaN])
  const [customers, setCustomers] = useState([])
  const [customerTypeListItem, setCustomerTypeListItem] = useState({})

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('users'))
      let api_result = await getData('admin/customers', 'get', {}, true)
      if (api_result) {
        if (api_result?.status === 200) {
          CustomersResponse(api_result, setCustomersType, setCustomerTypeListItem, setCustomers)
        }
      }
    }

    fetchData()
  }, [])

  const inputHandler = async (e) => {
    setSearchValue(e.target.value)

    customerSearchApi(e.target.value, customers, customersType, setCustomerTypeListItem)
  }

  const submitSearch = (e) => {
    e.preventDefault()
    customerSearchApi(search_value, customers, customersType, setCustomerTypeListItem)
  }
  return (
    <div>
      <SearchBox
        submitSearch={submitSearch}
        search_value={search_value}
        inputHandler={inputHandler}
      />

      <CustomerList
        search_value={search_value}
        customersType={customersType}
        openTab={openTab}
        setOpenTab={setOpenTab}
        customers={customers}
        setCustomers={setCustomers}
        customerTypeListItem={customerTypeListItem}
        setCustomerTypeListItem={setCustomerTypeListItem}
      />
    </div>
  )
}

export default memo(Users)
